export const MaskCPF = (v: string): string => {
  if (!v) return '';

  v = String(v);
  v = v.replace(/\D/g, '');
  v = v.replace(/(\d{3})(\d)/, '$1.$2');
  v = v.replace(/(\d{3})(\d)/, '$1.$2');
  v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  return v;
};

export const MaskCNPJ = (v: string): string => {
  if (!v) return '';

  v = String(v);
  v = v.replace(/\D/g, '');
  v = v.replace(/(\d{2})(\d)/, '$1.$2');
  v = v.replace(/(\d{3})(\d)/, '$1.$2');
  v = v.replace(/(\d{3})(\d)/, '$1/$2');
  v = v.replace(/(\d)(\d{2})$/, '$1-$2');
  return v;
};
export const maskTEL = (v: string): string => {
  if (!v) return '';

  v = String(v);
  v = v.replace(/\D/g, '');
  v = v.replace(/^(\d{2})(\d)/g, '($1) $2');
  v = v.replace(/(\d)(\d{4})$/, '$1-$2');
  return v;
};

export const maskLimited = (v: string): string => {
  if (!v) {
    return '';
  }
  v = String(v);
  v = v.slice(0, -1);
  return v;
};

export const maskCEP = (v: string): string => {
  if (!v) {
    return '';
  }
  v = v.replace(/\D/g, '');
  v = v.replace(/^(\d{5})(\d)/, '$1-$2');
  return v;
};

export const maskMoney = (valor: number): string => {
  if (!valor) {
    return '';
  }
  const valorStr = valor.toString();

  return valorStr.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};

export const maskMoneyWithText = (valor: number): string => {
  if (!valor) {
    return '';
  }

  if (valor >= 1000000) {
    const valorEmMilhoes = valor / 1000000;
    // Verifica se a parte decimal é zero
    if (valorEmMilhoes % 1 === 0) {
      return valorEmMilhoes.toFixed(0) + 'M'; // Sem casas decimais
    } else {
      // Remove o ".0" se houver, caso contrário mantém 1 casa decimal
      const valorFormatado = valorEmMilhoes.toFixed(1).replace(/\.0$/, '');
      return valorFormatado.replace('.', ',') + 'M';
    }
  } else if (valor >= 1000) {
    const valorEmMilhares = valor / 1000;
    // Verifica se a parte decimal é zero
    if (valorEmMilhares % 1 === 0) {
      return valorEmMilhares.toFixed(0) + ' mil'; // Sem casas decimais
    } else {
      // Remove o ".0" se houver, caso contrário mantém 1 casa decimal
      const valorFormatado = valorEmMilhares.toFixed(1).replace(/\.0$/, '');
      return valorFormatado.replace('.', ',') + ' mil';
    }
  }
};
